import axios from "axios"
import baseURL from "../configs/api"

export const getDiscounts = (tenantId: string) => {
    return getFetch("discount", tenantId)
}

export const getDiscountsByBranchId = (branchId: number, tenantId: string) => {
    return getFetch(`discount/GetDiscountsByBranchId/${branchId}`, tenantId)
}

export const getDiscount = (primaryKey: string, tenantId: string) => {
    return getFetch(`discount/${primaryKey}`, tenantId)
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}